<cads-field [config]="_fieldConfig()" [focused]="_focused()">
  @if (_leadingIconConfig(); as leading) {
    <span class="cads-field__leading" aria-hidden="true">
      <cads-icon-view-bit [config]="leading" />
    </span>
  }

  @if (_maskitoOptions(); as maskOpts) {
    <input
      #inputEl
      class="cads-input__el"
      [class.cads-input__el--no-spinners]="config().hideNumberSpinners && _type() === 'number'"
      [id]="_inputId()"
      [type]="_type()"
      [maskito]="maskOpts"
      [disabled]="_disabled()"
      [placeholder]="config().placeholder ?? ''"
      [attr.autocomplete]="config().autocomplete ?? null"
      [attr.inputmode]="config().inputMode ?? null"
      [attr.pattern]="config().pattern ?? null"
      [attr.maxlength]="config().maxLength ?? null"
      [attr.minlength]="config().minLength ?? null"
      [attr.min]="config().min ?? null"
      [attr.max]="config().max ?? null"
      [attr.step]="config().step ?? null"
      [attr.aria-invalid]="_hasError() ? 'true' : null"
      [attr.aria-required]="config().required === true ? 'true' : null"
      [attr.aria-describedby]="_showCaption() ? _captionId() : null"
      (input)="_onInput($event)"
      (focus)="_onFocus()"
      (blur)="_onBlur()"
      (keydown.enter)="_onKeydownEnter($event)"
    />
  } @else {
    <input
      #inputEl
      class="cads-input__el"
      [class.cads-input__el--no-spinners]="config().hideNumberSpinners && _type() === 'number'"
      [id]="_inputId()"
      [type]="_type()"
      [value]="_value()"
      [disabled]="_disabled()"
      [placeholder]="config().placeholder ?? ''"
      [attr.autocomplete]="config().autocomplete ?? null"
      [attr.inputmode]="config().inputMode ?? null"
      [attr.pattern]="config().pattern ?? null"
      [attr.maxlength]="config().maxLength ?? null"
      [attr.minlength]="config().minLength ?? null"
      [attr.min]="config().min ?? null"
      [attr.max]="config().max ?? null"
      [attr.step]="config().step ?? null"
      [attr.aria-invalid]="_hasError() ? 'true' : null"
      [attr.aria-required]="config().required === true ? 'true' : null"
      [attr.aria-describedby]="_showCaption() ? _captionId() : null"
      (input)="_onInput($event)"
      (focus)="_onFocus()"
      (blur)="_onBlur()"
      (keydown.enter)="_onKeydownEnter($event)"
    />
  }

  @if (_showTrailing()) {
    <button
      type="button"
      class="cads-field__trailing"
      [disabled]="_disabled()"
      aria-label="Clear"
      (click)="_onTrailingClick()"
    >
      @if (_trailingIconConfig(); as trailing) {
        <span class="cads-field__trailing-icon" aria-hidden="true">
          <cads-icon-view-bit [config]="trailing" />
        </span>
      }
    </button>
  }
  <ng-content select="[cadsFieldCaption]" />
</cads-field>
